import format from './format';
import system from './system';
import consumer from './consumer';
import robot from './robot';
import knowledge from './knowledge';
import recommend from './recommend';
import knowledgerate from './knowledgerate';
import buttons from './buttons';
import shortcuts from './shortcuts';

// new added
import welcomemsg from './welcomemsg';
import orderlist from './orderlist';
import orderdetail from './orderdetail';
import option from './option';
import express from './express';
import cancel from './cancelitems';
import evaluate from './evaluate';
import textlink from './textlink';
import requestLoginMessage from './request-login-message';
import agentChatLogin from './agent-chat-login';
import agent from './agent';
import fileTransferCustomer from './file-transfer-customer/file-transfer-customer';
import rarList from './rar/list';
import rarCard from './rar/card';
import orderSelector from './orderselector';
import { CARD_TYPES } from '../../const/objects.const';

import './base.scss';

export default function attachment(app) {
  app.register(format);
  app.register('notice', (data) => {
    console.log(data);
  });
  app.register('consumer', consumer);
  app.register(CARD_TYPES.ROBOT, robot);
  app.register(CARD_TYPES.ROBOT_LIVEAGENT, robot);
  app.register('knowledge', knowledge);
  app.register('recommend', recommend);
  app.register('knowledgerate', knowledgerate);
  app.register('system', system);
  app.register('buttons', buttons);
  app.register('dynamic_shortcuts', shortcuts);
  // new added
  app.register('welcomemsg', welcomemsg);
  app.register('orderlist', orderlist);
  app.register('option', option);
  app.register('orderdetail', orderdetail);
  app.register('express', express);
  app.register('cancel', cancel);
  app.register('feedback', evaluate);
  app.register('textlink', textlink);
  app.register('requestLoginMessage', requestLoginMessage);
  app.register('agentChatLogin', agentChatLogin);
  app.register('agent', agent);
  app.register('fileTransferCustomer', fileTransferCustomer);
  app.register('rarList', rarList);
  app.register('rarCard', rarCard);
  app.register('orderSelector', orderSelector);
}



// WEBPACK FOOTER //
// ./src/app/extension/index.js